import { render, staticRenderFns } from "./excursion-card.vue?vue&type=template&id=84763c60&scoped=true&"
import script from "./excursion-card.vue?vue&type=script&lang=ts&"
export * from "./excursion-card.vue?vue&type=script&lang=ts&"
import style0 from "./excursion-card.vue?vue&type=style&index=0&id=84763c60&prod&lang=scss&scoped=true&"
import style1 from "./excursion-card.vue?vue&type=style&index=1&id=84763c60&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84763c60",
  null
  
)

export default component.exports